import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 获取模板内容
 */
const getTemDetail = (vCom: any, params: any, loading: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_detail", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取测评量表
 */
const getTems = (vCom: any, params: any, loading: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export { getTemDetail, getTems }